export const COLLECTION_REQUEST = Symbol('COLLECTION_REQUEST');
export const COLLECTION_RESET = Symbol('COLLECTION_RESET');
export const COLLECTION_SET_IN_STORE = Symbol('COLLECTION_SET_IN_STORE');
export const COLLECTION_IS_LOADING = Symbol('COLLECTION_IS_LOADING');
export const COLLECTION_REQUEST_MOBILE = Symbol('COLLECTION_REQUEST_MOBILE');

/**
 * @param {number} collectionId
 * @param {number} pageNum
 * @param {number} perPage
 * @param {string} sortingBy
 * @param {boolean} featuredFirst
 * @return {{type: symbol, payload: {collectionId: number, sortingBy: string, pageNum: number}}}
 */
export const collectionRequestAction = (collectionId, pageNum, perPage, sortingBy, featuredFirst = false) => ({
  type: COLLECTION_REQUEST,
  payload: { collectionId, sortingBy, perPage, pageNum, featuredFirst },
});

/**
 * @param {CollectionModel.type} collection
 * @return {{type: COLLECTION_SET_IN_STORE, payload: {collection}}}
 */
export const collectionSetInStoreAction = (collection) => ({
  type: COLLECTION_SET_IN_STORE,
  payload: { collection },
});

export const collectionResetAction = () => ({
  type: COLLECTION_RESET,
});

export const collectionIsLoadingAction = () => ({
  type: COLLECTION_IS_LOADING,
});

export const collectionRequestOnMobileAction = (
  collectionId,
  pageNum,
  perPage,
  sortingBy,
  previousVideos = [],
  featuredFirst = false
) => ({
  type: COLLECTION_REQUEST_MOBILE,
  payload: {
    collectionId,
    pageNum,
    sortingBy,
    perPage,
    previousVideos,
    featuredFirst,
  },
});
